
<template>
    <div class="card flex justify-center">
        <Dialog v-model:visible="modalStore.isModalVisible"
                @hide="handleClose" modal :header="header" :style="{ width: '45vw' }" :breakpoints="{ '1199px': '65vw', '575px': '90vw' }">
            <RouterView v-slot="{ Component }">
                <component :is="Component" @closeModal="handleClose"></component>
            </RouterView>
        </Dialog>
    </div>
</template>

<script setup lang="ts">
import { routeNames } from '@/constants/route-details.constant';
import { useOpenModalAsRoute } from '@/store/useOpenModalAsRoute';

const router = useRouter();
const route = useRoute();

const modalStore = useOpenModalAsRoute();
const handleClose = () => {
  router.push({ name: route.meta.parentName });
  modalStore.handleClose();
};

const header = computed(() => modalStore.modalHeader || routeNames[route.name]?.uiLabel);
</script>
